// פרטי המפעיל ותאריכים לעמודים המשפטיים (תנאי שימוש, פרטיות, הצהרת נגישות) - מקום אחד למלא ולעדכן.
// שדה ריק מוצג באתר כ"[יש להשלים]" - לא לפרסם לפני שהכל מולא.

export const SITE = {
  name: 'זול בכפר',
  url: 'https://www.zolbakfar.com',

  // מי מפעיל את האתר: שם מלא או שם העסק, ומספר עוסק / ת"ז אם יש
  operatorName: '',
  operatorId: '',
  contactEmail: '',
  contactPhone: '',

  // רכז/ת הנגישות - חובה בהצהרת הנגישות (תקנה 35 לתקנות נגישות השירות)
  accessibilityCoordinator: { name: '', phone: '', email: '' },
  // מתי נבדקה הנגישות לאחרונה, ובידי מי (למשל "1.10.2026, בדיקה עצמית עם NVDA ומקלדת")
  accessibilityReviewedAt: '01.10.2026',
};

// גרסת תנאי השימוש. שינוי מהותי בתנאים → להעלות ב-1: כל משתמש קיים יתבקש לאשר מחדש בכניסה הבאה
// (Users.termsVersion, spAcceptTerms ב-Auth.sql)
export const TERMS_VERSION = 1;
export const TERMS_UPDATED = '1.10.2026';
export const PRIVACY_UPDATED = '1.10.2026';
export const ACCESSIBILITY_UPDATED = '1.10.2026';
